export const PRIORITIES = {
  critica: { label: "Crítica", dot: "#DC2626", bg: "#FEF2F2", text: "#DC2626", border: "#F87171" },
  alta: { label: "Alta", dot: "#EA580C", bg: "#FFF7ED", text: "#EA580C", border: "#FDBA74" },
  media: { label: "Media", dot: "#CA8A04", bg: "#FEFCE8", text: "#CA8A04", border: "#FDE047" },
  baja: { label: "Baja", dot: "#16A34A", bg: "#F0FDF4", text: "#16A34A", border: "#86EFAC" },
};

export const PRIORITY_ORDER = ["critica", "alta", "media", "baja"];

export const STATUSES = {
  pendiente: { label: "Pendiente", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  en_analisis: { label: "En análisis", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  pendiente_info_cliente: { label: "Pend. Info Cliente", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  en_desarrollo: { label: "En desarrollo", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  en_pruebas: { label: "En pruebas", cls: "bg-purple-50 text-purple-700 border-purple-200" },
  correccion: { label: "Corrección", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  aprobado: { label: "Aprobado", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  listo_deploy: { label: "Listo Deploy", cls: "bg-teal-50 text-teal-700 border-teal-200" },
  produccion_pendiente_firma: { label: "Prod. Pend. Firma", cls: "bg-green-50 text-green-700 border-green-300" },
  en_produccion: { label: "En Producción", cls: "bg-green-100 text-green-800 border-green-300" },
  capacitacion: { label: "Capacitación", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  entregado: { label: "Entregado", cls: "bg-lime-100 text-lime-800 border-lime-300" },
  cancelado: { label: "Cancelado", cls: "bg-zinc-100 text-zinc-500 border-zinc-300" },
};

export const STATUS_ORDER = [
  "pendiente", "en_analisis", "pendiente_info_cliente", "en_desarrollo", "en_pruebas",
  "correccion", "aprobado", "listo_deploy", "produccion_pendiente_firma", "en_produccion", "capacitacion", "entregado", "cancelado",
];

export const KANBAN_COLUMNS = [
  "pendiente", "en_analisis", "pendiente_info_cliente", "en_desarrollo", "en_pruebas",
  "correccion", "aprobado", "listo_deploy", "produccion_pendiente_firma", "en_produccion", "capacitacion", "entregado",
];

export const CHECKLIST_LABELS = {
  terminado: "Desarrollo terminado",
  pruebas_completas: "Pruebas completas",
  qa_aprobado: "QA aprobado",
  documentacion: "Documentación lista",
  usuario_aprobo: "Usuario aprobó",
  sin_errores_criticos: "Sin errores críticos",
};

export const ROLE_LABELS = {
  pm: "Director / PM",
  dev: "Desarrollador",
  qa: "QA",
  stakeholder: "Stakeholder",
};

export const MODULES = {
  dashboard: "Dashboard",
  desarrollos: "Desarrollos",
  tareas: "Tareas",
  deploys: "Próximos Deploys",
  riesgos: "Riesgos",
  reportes: "Reportes",
  organigrama: "Organigrama",
  usuarios: "Usuarios",
  configuracion: "Configuración",
};

export const MODULE_ORDER = ["dashboard", "desarrollos", "tareas", "deploys", "riesgos", "reportes", "organigrama", "usuarios", "configuracion"];

export const RISK_LEVELS = {
  alto: { label: "Alto", cls: "bg-red-50 text-red-700 border-red-300" },
  medio: { label: "Medio", cls: "bg-amber-50 text-amber-700 border-amber-300" },
  bajo: { label: "Bajo", cls: "bg-green-50 text-green-700 border-green-300" },
};

export const TASK_ESTADOS = {
  pendiente: { label: "Pendiente", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  en_progreso: { label: "En progreso", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  completada: { label: "Completada", cls: "bg-green-100 text-green-800 border-green-300" },
};

export const TASK_ESTADO_ORDER = ["pendiente", "en_progreso", "completada"];

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("es-ES", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return "—";
  }
}

export function isOverdue(iso, status) {
  if (!iso || ["pendiente_info_cliente", "produccion_pendiente_firma", "en_produccion", "capacitacion", "entregado", "cancelado"].includes(status)) return false;
  return new Date(iso) < new Date();
}
